/**
 * Traffic-light state for a job-readiness pre-flight check (WI 30856).
 * Mirrors the Sparta API `JobReadinessStatus` enum. The API has no
 * `JsonStringEnumConverter`, so the value arrives on the wire as the numeric
 * ordinal below — keep these numbers in sync with the C# enum.
 *
 * Ordered so the numerically-highest value is the most severe (overall status
 * is the worst check via Max). `NotEvaluated` sits below `Green` so a check that
 * could not be run yet never inflates the overall severity.
 */
export enum JobReadinessStatus {
  NotEvaluated = -1,
  Green = 0,
  Warn = 1,
  Red = 2,
}
